export default __webpack_public_path__ + "static/media/home-cases-vector.5cebbcbe.svg";